import client from '../plugins/axios'

export default {
  info: async (objNm) => {
    return await client.get(`/crud/info/${objNm}`)
  },
  list: async ({ objNm, page, perpage, search }) => {
    return await client.post(`/crud/list/${objNm}`,
      { page: page, search: search, perpage: perpage })
  },
  get: async ({ objNm, uid }) => {
    return await client.get(`/crud/${objNm}/${uid}`)
  },
  create: async ({ objNm, obj }) => {
    return await client.put(`/crud/${objNm}`, { obj: obj });
  },
  update: async ({ objNm, uid, obj }) => {
    return await client.patch(`/crud/${objNm}/${uid}`, { obj: obj });
  },
  delete: async ({ objNm, uid }) => {
    return await client.delete(`/crud/${objNm}/${uid}`);
  },
  userList: async ({ page, perpage, search }) => {
    return await client.post(`/crud/list/User`,
      { page: page, search: search, perpage: perpage })
  },

}



// WEBPACK FOOTER //
// ./src/api/crud.js